module.exports = __webpack_public_path__ + "resources/img/img_appguard1.cbd2f2a1c319b57e0628403ef40ffe5b.png";